/**
 * Get the current auth token, respecting admin impersonation.
 * During impersonation, the token is stored in sessionStorage (tab-scoped).
 * Otherwise, falls back to localStorage (normal auth flow).
 */
export function getAuthToken(): string | null {
  return sessionStorage.getItem('impersonation_token') || localStorage.getItem('auth_token');
}
